import { render } from "./FormularioCategoriaPlano.vue?vue&type=template&id=cd3006a6&scoped=true"
import script from "./FormularioCategoriaPlano.vue?vue&type=script&lang=js"
export * from "./FormularioCategoriaPlano.vue?vue&type=script&lang=js"

import "./FormularioCategoriaPlano.vue?vue&type=style&index=0&id=cd3006a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3006a6"]])

export default __exports__